export const es_ES = {
    "PREFIX" : {
        "QUESTION"     : "Pregunta",
        "QUESTION-PART": "Pregunta",
        "PRE-RELEASE"  : "Material general de ayuda",
        "JOURNAL"      : "Cuestionario"
    },
    "CONTENT": {
        "MARK"          : "punto{{totalMarks > 1 && 's' || ''}}"
    }
};